import axios from 'axios';
import useSWR from 'swr';

import { getApiUrl } from '@/helpers/api';

export const useConversations = ({ type, q } = {}) => {
  const params = new URLSearchParams();
  if (type) params.append('type', type);
  if (q) params.append('q', q);

  const urlStr = `${getApiUrl()}/conversation${
    params.toString() ? `?${params.toString()}` : ''
  }`;
  const swr = useSWR(urlStr, async (url) => {
    try {
      const result = await axios.get(url);
      return result.data;
    } catch (err) {
      throw Error(err);
    }
  });
  return swr;
};

export const useUnreadConversations = () => {
  const urlStr = `${getApiUrl()}/conversation/unread-structure`;
  const swr = useSWR(urlStr, async (url) => {
    try {
      const result = await axios.get(url);
      return result.data;
    } catch (err) {
      throw Error(err);
    }
  });
  return swr;
};

export const usePutReadConversation = () => {
  const putReadConversation = async (conversationId) => {
    try {
      const url = `${getApiUrl()}/conversation/${conversationId}/read`;
      const response = await axios.put(url);
      return response.data;
    } catch (err) {
      throw Error(err.response.data.message);
    }
  };

  return putReadConversation;
};

export const useConversation = (id) => {
  const urlStr = `${getApiUrl()}/conversation/${id}`;
  const swr = useSWR(urlStr, async (url) => {
    try {
      const result = await axios.get(url);
      return result.data;
    } catch (err) {
      throw Error(err);
    }
  });
  return swr;
};

export const usePostConversation = () => {
  const postConversation = async (payload) => {
    try {
      const url = `${getApiUrl()}/conversation`;
      const response = await axios.post(url, payload);
      return response.data;
    } catch (err) {
      throw Error(err.response.data.message);
    }
  };

  return postConversation;
};

export const usePostConversationMessage = () => {
  const postMessage = async (conversationId, payload) => {
    try {
      const url = `${getApiUrl()}/conversation/${conversationId}/message`;
      const response = await axios.post(url, payload);
      return response.data;
    } catch (err) {
      throw Error(err.response.data.message);
    }
  };

  return postMessage;
};
